import { useCallback, useMemo } from "react";
import { useTheme } from "styled-components";
import { generateLayouts, generateMappersForYAxis } from "views/components/visualizations/utils/chartLayoutGenerators";
import useWidgetUnits from "views/components/visualizations/hooks/useWidgetUnits";
import useFeature from "hooks/useFeature";
import { UNIT_FEATURE_FLAG } from "views/components/visualizations/Constants";
import useXAxisTicksAndType from "views/components/visualizations/hooks/useXAxisTicksAndType";
import getThresholdShapes from "views/components/visualizations/utils/getThresholdShapes";
import getPlotXTitleSettings from "views/components/visualizations/utils/getPlotXTitleSettings";
const useChartLayoutSettingsWithCustomUnits = ({
  config,
  barmode,
  chartData
}) => {
  const theme = useTheme();
  const ticksAndTypeConfig = useXAxisTicksAndType(config, chartData);
  const unitFeatureEnabled = useFeature(UNIT_FEATURE_FLAG);
  const widgetUnits = useWidgetUnits(config);
  const { unitTypeMapper, fieldNameToAxisNameMapper, mapperAxisNumber } = useMemo(
    () => generateMappersForYAxis({ series: config.series, units: widgetUnits }),
    [config.series, widgetUnits]
  );
  const { shapes: thresholdShapes, annotations: thresholdsAnnotations } = getThresholdShapes({
    series: config.series,
    widgetUnits,
    fieldNameToAxisNameMapper,
    mapperAxisNumber,
    theme
  });
  return useCallback(() => {
    if (!unitFeatureEnabled)
      return {
        xaxis: {
          ...ticksAndTypeConfig
        }
      };
    const generatedLayouts = generateLayouts({
      unitTypeMapper,
      barmode,
      chartData,
      widgetUnits,
      config,
      theme
    });
    const _layouts = {
      ...generatedLayouts,
      shapes: thresholdShapes,
      annotations: thresholdsAnnotations,
      hovermode: "x",
      xaxis: {
        title: getPlotXTitleSettings(theme, config),
        ...ticksAndTypeConfig
      }
    };
    return _layouts;
  }, [
    unitFeatureEnabled,
    ticksAndTypeConfig,
    unitTypeMapper,
    barmode,
    chartData,
    widgetUnits,
    config,
    theme,
    thresholdShapes,
    thresholdsAnnotations
  ]);
};
export default useChartLayoutSettingsWithCustomUnits;
